module.exports = __webpack_public_path__ + "img/degust-logo.f59a4d59.png";